import React, { memo } from 'react';
import { LoggableProps, useLogger } from '@direct-frontend/modules-logger';

import { cn } from '../../lib/css/className/className';
import { StatefulTooltip } from '../StatefulTooltip';
import { ClickableIcon } from '../ClickableIcon';
import { IconHelp } from '../../icons/colorless';

import { HelpProps } from './types';
import './Help.css';

export const clsHelp = cn('Help');

/**
 * Компонент для создания всплывающих подсказок по клику на иконку со знаком вопроса
 */
export const Help = memo<LoggableProps<HelpProps>>(function Help({
    className,
    iconClassName,
    iconContainerClassName,
    color,
    size,
    children,
    caption,
    isDisabled,
    hasClose,
    maxWidth,
    customContent,
    trigger = 'click',
    'data-testid': dataTestid,
    logNode,
    as,
    delay = 0,
    placement = 'bottom',
    flip = 'always',
    preventFocusOnPress,
    tooltipAutoFocusProps,
}) {
    const helpDataTestid = dataTestid ? `${dataTestid}.HelpButton` : 'HelpButton';
    const iconColor = color ?? (isDisabled ? 'gray' : 'current');

    const { LogProvider } = useLogger('Help', logNode);

    return (
        <LogProvider>
            <span className={clsHelp('iconContainer', [iconContainerClassName])}>
                <StatefulTooltip
                    className={clsHelp('tooltip', [className])}
                    title={children}
                    caption={caption}
                    color="inverted"
                    trigger={trigger}
                    delay={delay}
                    hasClose={hasClose}
                    maxWidth={maxWidth}
                    offset={4}
                    placement={placement}
                    customContent={customContent}
                    flip={flip}
                    autoFocusProps={tooltipAutoFocusProps}
                >
                    <ClickableIcon
                        className={clsHelp('icon', [iconClassName])}
                        isDisabled={isDisabled}
                        color={iconColor}
                        data-testid={helpDataTestid}
                        as={as}
                        logNode="HelpIcon"
                        preventFocusOnPress={preventFocusOnPress}
                    >
                        <IconHelp size={size} />
                    </ClickableIcon>
                </StatefulTooltip>
            </span>
        </LogProvider>
    );
});
